<template>
  <div :class="['content', { 'zh-style': lang === 'zh' }]">
    <empty-reminder v-if="records.length === 0 && !loading"></empty-reminder>

    <div id="pc-record-box" v-if="records.length > 0">
      <div class="little-title">
        <p class="time">{{ $t('time') }}</p>
        <p class="description">{{ $t('description') }}</p>
      </div>
      <div class="records" v-for="record in records">
        <p class="time">{{ record.created_at | createFormatTime(record.created_at) }}</p>
        <p class="description"><span>{{ $t('user') }}{{ record.nickname }}{{ $t(record.status) }}</span></p>
      </div>
    </div>

    <div id="pager-bar">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager :total-page="totalPage" :init-page="currentPage" @go-page="getRecords"></pager>
    </div>

  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import locales from './lang'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import Pager from '../../pager/Index.vue'

  export default {
    name: 'friend-records',
    components: {EmptyReminder, Spinner, Pager},
    props: ['initFriendRecords'],
    data: function () {
      return {
        records: [],
        loading: false,
        totalPage: 0,
        currentPage: 1
      }
    },
    locales,
    watch: {
      initFriendRecords() {
        this.records = this.initFriendRecords.data
        this.totalPage = Math.ceil(this.initFriendRecords.meta['total'] / this.initFriendRecords.meta['per_page'])
        this.currentPage = this.initFriendRecords.meta['current_page']
      }
    },
    computed: {
      lang() {
        return this.$store.state.currentLang
      }
    },
    methods: {
      getRecords(data) {
        this.loading = true
        this.$http.get('api/invitation-records/commission', {params: {'page': data.page}}).then(response => {
          this.loading = false
          this.records = response.data.data
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
          this.currentPage = response.data.meta['current_page']
        }, response => {
          this.loading = false
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .content {
    min-height: 2.16rem;
  }

  #pc-record-box {
    min-height: 4.5rem;
  }

  .little-title {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #333333;
    font-weight: 600;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    display: flex;
  }

  .records {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #666;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    display: flex;
  }

  p {
    font-size: .14rem;
    display: inline-block;
  }

  .time {
    text-align: center;
    flex-basis: 25%;
  }

  .description {
    text-align: center;
    flex-basis: 75%;
    span {
      display: inline-block;
      width: 100%;
    }
  }

  @mixin zh-style() {
    .description span {
      @media screen and (min-width: 807px) {
        padding-right: 0;
        width: 4.16rem;
      }
    }
  }

  .zh-style {
    @include zh-style();
  }

  #pager-bar {
    padding-bottom: .4rem;
    text-align: center;
    .spinner-component-box {
      min-height: .8rem;
      padding: .1rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// FriendRecordsPc.vue?1181d644